'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiThirdParty = function (_React$Component) {
    _inherits(AiThirdParty, _React$Component);

    function AiThirdParty() {
        _classCallCheck(this, AiThirdParty);

        return _possibleConstructorReturn(this, (AiThirdParty.__proto__ || Object.getPrototypeOf(AiThirdParty)).apply(this, arguments));
    }

    _createClass(AiThirdParty, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M52,44c0,1.3-0.4,2.4-1.2,3.1c-0.8,0.8-1.9,1.1-3.2,1.1H33.2c-1.3,0-2.4-0.4-3.2-1.1c-0.8-0.8-1.2-1.8-1.2-3.1 c0-0.6,0-1.1,0.1-1.7c0-0.6,0.1-1.2,0.2-1.8c0.1-0.6,0.3-1.2,0.4-1.8c0.2-0.5,0.4-1.1,0.7-1.6c0.3-0.5,0.6-1,1-1.3 c0.4-0.4,0.9-0.7,1.4-0.9c0.6-0.2,1.2-0.3,1.8-0.3c0.1,0,0.3,0.1,0.7,0.4c0.4,0.2,0.8,0.5,1.2,0.8c0.5,0.3,1,0.6,1.8,0.8 c0.7,0.2,1.5,0.4,2.2,0.4c0.7,0,1.5-0.1,2.2-0.4c0.7-0.2,1.3-0.5,1.8-0.8c0.5-0.3,0.9-0.6,1.2-0.8c0.4-0.2,0.6-0.4,0.7-0.4 c0.7,0,1.3,0.1,1.8,0.3c0.6,0.2,1,0.5,1.4,0.9c0.4,0.4,0.7,0.8,1,1.3c0.3,0.5,0.5,1.1,0.7,1.6c0.2,0.5,0.3,1.1,0.4,1.8 c0.1,0.6,0.2,1.2,0.2,1.8C52,42.8,52,43.4,52,44z M44.6,22.8c1.1,1.3,1.7,2.8,1.7,4.6s-0.6,3.3-1.7,4.6c-1.1,1.3-2.5,1.9-4.2,1.9 c-1.6,0-3-0.6-4.2-1.9c-1.2-1.3-1.7-2.8-1.7-4.6s0.6-3.3,1.7-4.6c1.1-1.3,2.5-1.9,4.2-1.9C42,20.9,43.4,21.5,44.6,22.8z' }),
                    _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M21.6,26.5c1.3,0,2.5-0.5,3.5-1.6c1-1.1,1.4-2.3,1.4-3.8c0-1.5-0.5-2.8-1.4-3.8c-1-1-2.1-1.6-3.5-1.6 c-1.3,0-2.5,0.5-3.5,1.6c-1,1.1-1.4,2.3-1.4,3.8c0,1.5,0.5,2.8,1.4,3.8C19.1,26,20.3,26.5,21.6,26.5z' }),
                        _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M26.5,37.7c0.2-0.8,0.6-1.5,1-2.2c0.4-0.8,1-1.5,1.6-2.1c0.6-0.5,1.2-1,2-1.3c0,0,0,0,0-0.1c-0.1-0.5-0.2-1-0.4-1.5 c-0.1-0.5-0.3-0.9-0.6-1.3c-0.2-0.4-0.5-0.8-0.8-1.1c-0.3-0.3-0.7-0.5-1.2-0.7c-0.5-0.2-1-0.3-1.5-0.3c-0.1,0-0.3,0.1-0.6,0.3 c-0.3,0.2-0.6,0.4-1,0.7c-0.4,0.2-0.9,0.5-1.5,0.7c-0.6,0.2-1.2,0.3-1.8,0.3c-0.6,0-1.2-0.1-1.8-0.3c-0.6-0.2-1.1-0.4-1.5-0.7 c-0.4-0.2-0.7-0.5-1-0.7c-0.3-0.2-0.5-0.3-0.6-0.3c-0.6,0-1.1,0.1-1.5,0.3c-0.5,0.2-0.8,0.4-1.2,0.7c-0.3,0.3-0.6,0.7-0.8,1.1 c-0.2,0.4-0.4,0.9-0.6,1.3c-0.1,0.5-0.3,1-0.4,1.5c-0.1,0.5-0.2,1-0.2,1.5c0,0.5,0,0.9,0,1.4c0,1.1,0.3,2,1,2.6 c0.7,0.6,1.5,1,2.6,1h10.6C26.3,38.2,26.4,38,26.5,37.7z' })
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '10 10 44 44';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-third-party', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-third-party', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiThirdParty;
}(_react2.default.Component);

exports.default = AiThirdParty;